import { newActionId, revokeInvite, rotateInvite } from "../data/callables";
import type { EnqueueCommand, RunCommand } from "./commandTypes";
import type { TeamCommands } from "./teamTypes";
import { actionKeys } from "./actionKeys";
import { eventRecovery } from "./useSerializedGameQueue";

interface InviteCommandOptions {
  teamId: string;
  run: RunCommand;
  enqueue: EnqueueCommand;
}

export type InviteCommands = Pick<
  TeamCommands,
  "rotateInviteLink" | "revokeInviteLink"
>;

export function useInviteCommands({
  teamId,
  run,
  enqueue,
}: InviteCommandOptions): InviteCommands {
  const rotateInviteLink = (): Promise<boolean> => {
    const actionId = newActionId();
    return enqueue(() => run(() => rotateInvite({ teamId, actionId })), {
      key: actionKeys.inviteRotate,
      chainKey: "invite",
      intentId: actionId,
      recovery: eventRecovery(teamId, actionId),
    }) as Promise<boolean>;
  };
  const revokeInviteLink = (): Promise<boolean> => {
    const actionId = newActionId();
    return enqueue(() => run(() => revokeInvite({ teamId, actionId })), {
      key: actionKeys.inviteRevoke,
      chainKey: "invite",
      intentId: actionId,
      recovery: eventRecovery(teamId, actionId),
    });
  };

  return { rotateInviteLink, revokeInviteLink };
}
